import { VBModal } from './modal';
import { pluginFactory } from '../../utils/plugins';
var VBModalPlugin =
/*#__PURE__*/
pluginFactory({
  directives: {
    VBModal: VBModal
  }
});
export { VBModalPlugin, VBModal };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/directives/modal/index.js
// module id = 380
// module chunks = 0 1 2 3 4 5 6 7